import { Pagination } from "services/search";

import {
  CatalogVehicleResult,
  Vehicle,
  VehicleCategory,
  VehicleEditFormValues,
  VehicleImage,
  VehicleRow,
} from "./types";

import { DataWithPagination } from "services/api/types";
import {
  // transformFuelTypes,
  transformVehicle,
  transformVehicleCategory,
  transformVehicleImage,
  transformVehicleOnCreate,
  transformVehicleOnUpdate,
  transformVehicleRow,
  // transformVehicleStatus,
} from "./transformations";
import { createApiCall, paginatedApiCall } from "services/api/createApiCall";
// import { VehicleCategory } from "./categories/types";

/*---------------------------------------------------------------------------------------
  SEARCH
-----------------------------------------------------------------------------------------*/
export const getVehiclesAPI = async (
  pagination: Pagination,
  name?: string | null,
  vehicleManufacturerId?: string | null,
  vehicleModelId?: string | null,
  vehicleTypeId?: string | null,
  rentMonths?: number | null,
  rentKm?: number | null,
  availableNow?: boolean | null
): Promise<DataWithPagination<VehicleRow>> => {
  let path = `/v1/catalog/vehicles?name=`;

  if (name) path += `${name}`;
  if (vehicleManufacturerId)
    path += `&vehicleManufacturerId=${vehicleManufacturerId}`;
  if (vehicleModelId) path += `&vehicleModelId=${vehicleModelId}`;
  if (vehicleTypeId) path += `&vehicleTypeId=${vehicleTypeId}`;
  if (rentMonths) path += `&rentMonths=${rentMonths}`;
  if (rentKm) path += `&rentKm=${rentKm}`;
  if (availableNow) path += `&availableNow=${availableNow}`;

  return await paginatedApiCall(path, pagination, transformVehicleRow);
};

/*---------------------------------------------------------------------------------------
    INFO
  -----------------------------------------------------------------------------------------*/
export const getVehicleAPI = async (id: string): Promise<Vehicle> => {
  const response = await createApiCall(
    {
      path: `/v1/catalog/vehicles/${id}`,
      method: "GET",
    },
    {
      getMessage: {
        error: (error: any) => `${error.response.data.message}`,
      },
    }
  )();

  return transformVehicle(response.data);
};

export const getVehicleImagesAPI = async (
  id: string
): Promise<VehicleImage> => {
  const response = await createApiCall(
    {
      path: `/v1/catalog/vehicles/${id}/images`,
      method: "GET",
    },
    {
      getMessage: {
        error: (error: any) => `${error.response.data.message}`,
      },
    }
  )();

  return transformVehicleImage(response.data);
};

export const createVehicleAPI = async (
  vehicleEditFormValues: VehicleEditFormValues
): Promise<Vehicle> => {
  const response = await createApiCall(
    {
      path: "/v1/vehicles/",
      method: "POST",
      body: transformVehicleOnCreate(vehicleEditFormValues),
    },
    {
      getMessage: {
        success: () => "Marka je uspješno kreiran",
        error: (error: any) => `${error.response.data.message}`,
      },
    }
  )();

  return transformVehicle(response.data);
};

export const updateVehicleAPI = async (
  id: string,
  vehicleEditFormValues: VehicleEditFormValues
): Promise<Vehicle> => {
  const response = await createApiCall(
    {
      path: `/v1/vehicles/${id}`,
      method: "PUT",
      body: transformVehicleOnUpdate(vehicleEditFormValues),
    },
    {
      getMessage: {
        success: () => "Marka je uspješno ažuriran",
        error: (error: any) => `${error.response.data.message}`,
      },
    }
  )();

  return transformVehicle(response.data);
};


/*---------------------------------------------------------------------------------------
  CVH
-----------------------------------------------------------------------------------------*/
export const getVehiclesByCvhJomAPI = async (
  jom: string,
  pagination: Pagination
): Promise<DataWithPagination<CatalogVehicleResult>> => {
  return await paginatedApiCall(
    `/v1/catalog/vehicles/cvh/jom/${encodeURIComponent(jom)}`,
    pagination,
    (res: any): CatalogVehicleResult => ({
      id: res.vehicleType?.id ?? "",
      vehicleManufacturer: res.vehicleManufacturer ?? null,
      vehicleModel: res.vehicleModel ?? null,
      vehicleType: res.vehicleType ?? null,
    })
  );
};

export const getVehicleCategoriesAPI = async (): Promise<VehicleCategory[]> => {
  const response = await createApiCall(
    {
      path: `/v1/catalog/vehicles/categories`,
      method: "GET",
    },
    {
      getMessage: {
        error: (error: any) => `${error.response.data.message}`,
      },
    }
  )();

  return response.data.results.map(transformVehicleCategory);
};


// export const getVehicleStatusAPI = async (): Promise<VehicleStatus[]> => {
//   const response = await createApiCall(
//     {
//       path: `/v1/vehicles/status`,
//       method: "GET",
//     },
//     {
//       getMessage: {
//         error: (error: any) => `${error.response.data.message}`,
//       },
//     }
//   )();

//   return response.data.map(transformVehicleStatus);
// };

// export const getFuelTypesAPI = async (): Promise<FuelType[]> => {
//   const response = await createApiCall(
//     {
//       path: `/v1/vehicles/fueltypes`,
//       method: "GET",
//     },
//     {
//       getMessage: {
//         error: (error: any) => `${error.response.data.message}`,
//       },
//     }
//   )();

//   return response.data.map(transformFuelTypes);
// };

